import React, {useState} from 'react';
import {createUseStyles} from 'react-jss';
import Select, {components} from 'react-select';
import clsx from 'clsx';

import {mobileSelectorStyles} from '../../common-styles/selector-style';
import {
  CLOSE_LOCATION,
  LOCATION_TRANSLATE,
  OPEN_LOCATION,
  SELECT_LOCATION
} from '../../utils/action-types';
import {DEFAULT_LANGUAGE, RU_LANGUAGE, SELECTED_CITY} from '../../utils/constants';
import {setCookie} from '../../utils/cookie';
import {getCityTranslateByKey} from '../../utils/helpers';
import {COLORS} from '../../utils/style-variables';

import {locationSelectorHoc} from './location-selector-hoc';

const useStyles = createUseStyles({
  selectLocationButton: {
    display: 'block',
    width: '100%',
    position: 'relative',
    textAlign: 'left',
    padding: '9px 30px 9px 16px',
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: COLORS.lightGrey60Color,
    borderRadius: '2px',
    backgroundColor: 'transparent',
    fontSize: '15px',
    lineHeight: '20px',
    color: '#000',
    appearance: 'none',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    '&:after': {
      content: '""',
      borderStyle: 'solid',
      borderWidth: '2px 2px 0 0',
      borderColor: '#757575',
      display: 'inline-block',
      position: 'absolute',
      width: 8,
      height: 8,
      top: 'calc(50% - 6px)',
      right: 16,
      transform: 'rotate(135deg)',
      verticalAlign: 'top'
    },
    '&.open': {
      '&:after': {
        top: 'calc(50% - 4px)',
        transform: 'rotate(-45deg)'
      }
    }
  },
  selectLocationWrapper: {
    display: 'inline-block',
    width: 'calc(100% / 2 - 8px)'
  },
  selectWrapper: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    top: 0,
    right: 0,
    zIndex: 15,
    backgroundColor: '#fff'
  },
  modalSelectHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '16px',
    background: '#fff',
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
    fontWeight: 500,
    fontSize: '15px',
    lineHeight: '20px',
    letterSpacing: '0.3px',
    color: COLORS.blackColor,
    '& > span': {
      textDecoration: 'underline',
      color: COLORS.blue100Color
    }
  },
  clear: {
    position: 'relative',
    padding: 15,
    '&:before, &:after': {
      position: 'absolute',
      top: 11,
      left: 15,
      content: '" "',
      height: 10,
      width: 2,
      backgroundColor: COLORS.greyColor
    },
    '&:before': {
      transform: 'rotate(45deg)'
    },
    '&:after': {
      transform: 'rotate(-45deg)'
    }
  }
});

const mobileLocation = ({listData, changeLocation, state: {open_location_select, locationTranslate}}) => {
  const [searchInput, setSearchInput] = useState('');
  const classes = useStyles();
  const selectLocation = value => {
    changeLocation({
      type: SELECT_LOCATION,
      payload: value
    });
    changeLocation({
      type: LOCATION_TRANSLATE,
      payload: getCityTranslateByKey(value.key)
    });

    // setUp cookies for 365 days
    setCookie(SELECTED_CITY, JSON.stringify(value), 24 * 365);

  };
  const resetSearch = () => {
    setSearchInput('');
  };
  const Control = props => (
    <div className={classes.modalSelectHeader}>
      <components.Control {...props}>{props.children}</components.Control>
      <span onClick={() => changeLocation({type: CLOSE_LOCATION})}>Закрыть</span>
    </div>
  );
  const IndicatorsContainer = () => <div className={classes.clear} onClick={resetSearch} />;

  return (
    <div className={classes.selectLocationWrapper}>
      <button
        className={clsx(classes.selectLocationButton, {open_location_select})}
        onClick={() => changeLocation({type: OPEN_LOCATION})}
      >
        {locationTranslate[DEFAULT_LANGUAGE]?.nominative}
      </button>
      {open_location_select &&
      <div className={classes.selectWrapper}>
        <Select
          components={{Control, IndicatorsContainer, DropdownIndicator: null}}
          backspaceRemovesValue={false}
          controlShouldRenderValue={false}
          hideSelectedOptions={false}
          isClearable={false}
          menuIsOpen
          onChange={selectLocation}
          defaultInputValue={searchInput}
          noOptionsMessage={() => 'Не найдено'}
          placeholder='Населенный пункт'
          tabSelectsValue={false}
          styles={mobileSelectorStyles}
          options={listData}
          getOptionLabel={option => option[RU_LANGUAGE]}
          getOptionValue={option => option.key}
        />
      </div>}
    </div>
  );
};

export default locationSelectorHoc(mobileLocation);

